import { routeCreator as awardCatalogRouteCreator } from '@occc-app/routes/AwardCatalog/utils';
import { routeCreator as campaignRouteCreator } from '@occc-app/routes/Campaign/utils';
import { createRouteCreator as createProgramManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';
import { engagementTypeToOfferTypeMap } from '@occc-app/offerValidationService/constants';
import { OfferType } from '@occc-app/offerValidationService/types';
import { Offer_Engagement_Type } from '@occc/graphql';

export type OfferLinkInfo = {
  id: string;
  name: string;
  url: string;
};

const PROGRAM_MANAGEMENT_OFFER_TYPES = [
  OfferType.LoyaltyEvent,
  OfferType.VoucheredGame,
  OfferType.FreeGame,
];

export const getOfferDetailsUrl = (
  offerId: string,
  engagementType?: Offer_Engagement_Type | null,
  campaignId?: string | null,
): string => {
  if (campaignId) {
    return campaignRouteCreator.offerDetails(campaignId, offerId);
  }

  const offerType = engagementType ? engagementTypeToOfferTypeMap[engagementType] : undefined;

  return offerType && PROGRAM_MANAGEMENT_OFFER_TYPES.includes(offerType)
    ? createProgramManagementRouteCreator(offerType).details(offerId)
    : awardCatalogRouteCreator.details(offerId);
};
